import React, { useState } from 'react'
import Modal from './Modal'
import DateRangePicker from './DateRangePicker'

export default function CustomPeriodFilter({ handleFilterPeriod, period, open }) {
  const [range, setRange] = useState(null)
  const [error, setError] = useState('')

  const transformToUnix = (date) => {
    if (!date) return null
    return Math.floor(new Date(date).getTime() / 1000)
  }

  const getDateFromUnix = (unixTimestamp) => {
    if (!unixTimestamp) return null
    return new Date(unixTimestamp * 1000)
  }

  const onFilterButtonClick = () => {
    if (!range || !range.start || !range.end) {
      setError('Please select a valid date range.')
      return
    }
    handleFilterPeriod(`${transformToUnix(range.start)}:${transformToUnix(range.end)}`)
  }

  const getDefaultRange = () => {
    if (!period) return {}

    const [start, end] = period.split(':')
    if (!start || !end) return {}

    return {
      defaultRange: {
        start: getDateFromUnix(parseInt(start)),
        end: getDateFromUnix(parseInt(end)),
      },
    }
  }

  return (
    <Modal styleClass="overflow-visible" isOpen={open} onClose={() => handleFilterPeriod(null)}>
      <div>
        <h2 className="text-lg font-semibold mb-4">Select Date Range</h2>
        <p className="text-sm text-gray-500 mb-2">Choose a custom date range for your filter.</p>
        <div className="flex flex-col items-center  [&>.flatpickr-wrapper]:w-full">
          <DateRangePicker
            value={range}
            onChange={(range) => {
              setRange(range)
              setError('') // Clear error when a valid range is selected
            }}
            {...getDefaultRange()}
          />
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </div>
        <button
          className="mt-4 px-4 py-2 bg-secondary-600 text-white rounded hover:bg-secondary-600-dark"
          onClick={onFilterButtonClick}
        >
          Filter by Date
        </button>
      </div>
    </Modal>
  )
}
